import type { DialogProps } from '@radix-ui/react-dialog';
import type { PredictionRoundParticipation } from '@store:web/components/pages/MagicPredictionsPage/model/AdjacentRound/roundParticipation';
import { CustomDialog } from '@ui/uikit/components/common/Dialog';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import type { PredictionDirection } from '../../../../../../../model/PredictionDirection';
import { MakePredictionForm } from './MakePredictionForm';

type Props = DialogProps & {
  closeModal: () => void;
  defaultDirection: PredictionDirection;
  round: AdjacentRound;
  participation: PredictionRoundParticipation;
};

export const MakePredictionModal = ({
  closeModal,
  defaultDirection,
  round,
  participation,
  ...props
}: Props) => {
  const onSubmitHandler = () => {
    closeModal();
  };

  return (
    <CustomDialog {...props} title="Your Prediction" titleIsLeftAligned size="sm">
      <MakePredictionForm
        round={round}
        onSubmit={onSubmitHandler}
        defaultDirection={defaultDirection}
        participation={participation}
      />
    </CustomDialog>
  );
};
